import { RootState } from '@/App/store';

export const selectHoroscopeInput = (state: RootState) => state.horoscope;
